import { render, staticRenderFns } from "./UDEBNIMG.vue?vue&type=template&id=3bae2430&scoped=true"
import script from "./UDEBNIMG.vue?vue&type=script&lang=js"
export * from "./UDEBNIMG.vue?vue&type=script&lang=js"
import style0 from "./UDEBNIMG.vue?vue&type=style&index=0&id=3bae2430&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bae2430",
  null
  
)

export default component.exports